import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=c5877818&"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js&"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
